export enum ENUM_PAGE_FILTER {
  ORDER = "order",
  OFFER = "offer",
  PLATFORM = "platform",
  CART = "cart",
}
